<template>
    <div class="classSystem">
      <div class="container">
        <div class="class-header">
          <swiper></swiper>
        </div>
        <div class="class-contens">
          <div class="item-class-contens">
            <div class="class-contens-title"><i></i>课程体系<i></i></div>
            <ul class="classNav">
              <li v-for="(item,index) in chessList" :key="index" @click="tabNav(index)">
                <img :src="item.img">
              </li>
            </ul>
            <div class="class-cons-content">
              <img :src="img.url"/>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import Swiper from '../components/swiper.vue'
export default {
  name: 'classSystem',
  components: {
    Swiper
  },
  data () {
    return {
      chessList: [
        {img: require('../assets/teacher/xqd.png')},
        {img: require('../assets/teacher/wqb.png')},
        {img: require('../assets/teacher/gxb.png')}
      ],
      img: {url: require('../assets/teacher/xq.png')}
    }
  },
  methods: {
    tabNav (v) {
      if (v === 0) {
        this.chessList = [
          {img: require('../assets/teacher/xqd.png')},
          {img: require('../assets/teacher/wqb.png')},
          {img: require('../assets/teacher/gxb.png')}
        ]
        this.img = {url: require('../assets/teacher/xq.png')}
      } else if (v === 1) {
        this.chessList = [
          {img: require('../assets/teacher/xqb.png')},
          {img: require('../assets/teacher/wqd.png')},
          {img: require('../assets/teacher/gxb.png')}
        ]
        this.img = {url: require('../assets/teacher/wq.png')}
      } else {
        this.chessList = [
          {img: require('../assets/teacher/xqb.png')},
          {img: require('../assets/teacher/wqb.png')},
          {img: require('../assets/teacher/gxd.png')}
        ]
        this.img = {url: require('../assets/teacher/gx.png')}
      }
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../assets/scss/base.scss";
  @import "../assets/scss/mixin.scss";
  @import "../assets/scss/config.scss";
  .classSystem{
    width: 100%;
    @media only screen and (min-width: 540px) and (max-width: 1180px){
      width: 1180px;
    }
    .container{
      width: 100%;
      .class-header{
        width: 100%;
        height: 450px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .class-contens {
        width: 1180px;
        text-align: center;
        margin: auto;
        margin-top: 40px;
        .item-class-contens {
          width: 100%;
          margin-bottom: 45px;
          .class-contens-title {
            color: $colorB;
            font-size: $fontB;
            font-weight: bold;
            i{
              display: inline-block;
              width: 23px;
              height: 23px;
              margin-right: 26px;
              @include bgImg(23px,23px,'../assets/imgs/san_left.png');
            }
            i:last-of-type{
              margin-left: 26px;
              @include bgImg(23px,23px,'../assets/imgs/san_right.png');
            }
          }
          .classNav{
            width: 100%;
            margin: 36px 0 49px 0;
            display: flex;
            justify-content: space-evenly;
            img{
              width: 100%;
              height: 100%;
              cursor: pointer;
            }
          }
          .class-cons-content {
            width: 1180px;
            // height: 683px;
            margin: auto;
            @include flex();
            margin-bottom: 100px;
            img{
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/classSystem.vue